import React, { useEffect } from "react";
import { isEmpty, toastr } from "../../common/cores";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MobileStickyFootbar from "./MobileStickyFootbar";

const Footbar = (props) => {
  const { isAuthenticated, language } = props;

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  useEffect(() => {}, [language]);
  return (
    <div className="footer">
      <div className="cs">
        <div className="inner">
          <p className="tit_help" langkey="new_theme.common.help_title">
            {isEmpty(window.lang["도움이 필요하세요?"])
              ? "도움이 필요하세요?"
              : window.lang["도움이 필요하세요?"]}
          </p>
          <div className="sec01"> </div>
          <div className="sec02">
            {" "}
            <strong className="" langkey="new_theme.common.24hours_title">
              {isEmpty(window.lang["운영시간"])
                ? "운영시간"
                : window.lang["운영시간"]}{" "}
              : 24{isEmpty(window.lang["시간"]) ? "시간" : window.lang["시간"]}
            </strong>
            <p>
              <span className="" langkey="new_theme.common.24hours_desc">
                {isEmpty(
                  window.lang[
                    "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                  ]
                )
                  ? "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                  : window.lang[
                      "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                    ]}{" "}
              </span>
            </p>
          </div>
          <div className="csBtns">
            <Link
              to="/inquiries/rule"
              className=""
              langkey="col.cs_center"
              onClick={onClickMemMenu}
            >
              {isEmpty(window.lang["고객센터"])
                ? "고객센터"
                : window.lang["고객센터"]}
            </Link>
            <Link
              to="/inquiries/question"
              className=""
              langkey="col.cs_center"
              onClick={onClickMemMenu}
            >
              {isEmpty(window.lang["1:1문의"])
                ? "1:1문의"
                : window.lang["1:1문의"]}
            </Link>
          </div>
        </div>
      </div>
      <div className="foot_con">
        <p
          className="foot_logo invisible"
          id="main_footer_logo"
          style={{ visibility: "visible" }}
        ></p>
        <div className="partners">
          <div
            className="swiper-container pt40 pb40 footerBanner_marquee"
            id="footerBanner"
          >
            <ul
              className="swiper-wrapper"
              style={{
                animation:
                  " 76s linear 0s infinite normal none running scroll-footerBanner",
              }}
            >
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TUt6_B90L_ms0z_wIKT.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/wLtD_hZPa_myUP_A2N5.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/cLBQ_GM2A_hJyF_5Xt1.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/bl6P_UzRi_AobQ_v8px.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/mu0z_5yQb_f7vV_bQvc.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rRTl_JoQJ_ccQv_uHDy.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/Ml3d_cNcQ_v5Kf_Vo3K.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/H64B_n6M0_O0cc_1DLR.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rdbX_EfE9_N53N_LrET.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/vc7Q_wP4B_g3qE_LVQI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gr39_98CY_rGto_pZ7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XsCs_qEiN_SYHQ_BDyX.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/FX9Y_rqT9_OI2q_GEO7.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XOqm_wxpB_0ZHY_0F7w.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/UE3K_1Ksa_Vkev_xh8h.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1025/9Mcc_Emhw_VpAy_Z2Rp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/3xcR_A8mj_xIYZ_6F9G.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/GaNl_royr_FLi6_Gv7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/LWai_q3Zp_qOaY_zcei.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gtuq_aYiO_NkPi_vo8p.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/EuP4_SpLR_Xwya_MNaW.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/AUc3_3oAv_PA8C_KjhJ.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/hPJr_b1zb_TNML_v3BH.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/t4Km_yKDA_Kqm8_2JkI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/u8Ex_Q8yV_QsOK_VhSM.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/ZZs2_OGyB_yn2i_cRb3.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0126/cAIj_Leip_DXxM_yD6C.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/SBDe_IonT_88Lz_Z2jf.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/rXAz_v8jc_g1sl_9TI9.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/n5sX_FiTr_sNiv_w79T.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/BuhV_T9xh_Ecyh_ZiRd.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/dqCZ_4kwE_3432_NA6R.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TaIA_1Ba8_yOUt_qTsL.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/h2t2_is0F_uzuv_822Q.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/77j0_UQAY_6Ox7_OG0X.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0304/ImQd_mPS6_fUCI_AFRp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/J8Np_Wpk7_RYeq_m2Ap.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TUt6_B90L_ms0z_wIKT.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/wLtD_hZPa_myUP_A2N5.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/cLBQ_GM2A_hJyF_5Xt1.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/bl6P_UzRi_AobQ_v8px.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/mu0z_5yQb_f7vV_bQvc.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rRTl_JoQJ_ccQv_uHDy.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/Ml3d_cNcQ_v5Kf_Vo3K.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/H64B_n6M0_O0cc_1DLR.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rdbX_EfE9_N53N_LrET.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/vc7Q_wP4B_g3qE_LVQI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gr39_98CY_rGto_pZ7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XsCs_qEiN_SYHQ_BDyX.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/FX9Y_rqT9_OI2q_GEO7.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XOqm_wxpB_0ZHY_0F7w.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/UE3K_1Ksa_Vkev_xh8h.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1025/9Mcc_Emhw_VpAy_Z2Rp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/3xcR_A8mj_xIYZ_6F9G.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/GaNl_royr_FLi6_Gv7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/LWai_q3Zp_qOaY_zcei.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gtuq_aYiO_NkPi_vo8p.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/EuP4_SpLR_Xwya_MNaW.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/AUc3_3oAv_PA8C_KjhJ.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/hPJr_b1zb_TNML_v3BH.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/t4Km_yKDA_Kqm8_2JkI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/u8Ex_Q8yV_QsOK_VhSM.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/ZZs2_OGyB_yn2i_cRb3.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0126/cAIj_Leip_DXxM_yD6C.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/SBDe_IonT_88Lz_Z2jf.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/rXAz_v8jc_g1sl_9TI9.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/n5sX_FiTr_sNiv_w79T.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/BuhV_T9xh_Ecyh_ZiRd.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/dqCZ_4kwE_3432_NA6R.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TaIA_1Ba8_yOUt_qTsL.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/h2t2_is0F_uzuv_822Q.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/77j0_UQAY_6Ox7_OG0X.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0304/ImQd_mPS6_fUCI_AFRp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/J8Np_Wpk7_RYeq_m2Ap.png"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="util">
        <div
          className="inner"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-around",
            background: "#222222",
            padding: 30,
            gap: 30,
            flexWrap: "wrap",
          }}
        >
          <div
            className="connectus_temp"
            style={{
              textAlign: "center",
            }}
          >
            <p
              className="tit"
              langkey="title.connection_we"
              style={{ fontSize: "18px", marginBottom: 25, color: "white" }}
            >
              {isEmpty(window.lang["우리와의 연결"])
                ? "우리와의 연결"
                : window.lang["우리와의 연결"]}
            </p>
            <div>
              <a href="https://www.google.com/chrome/" target="_blank">
                <img
                  src="../images/upload/2024/0120/yei4_MVux_V01J_eZfv.png"
                  alt=""
                />
              </a>
            </div>
            <p
              className="noti"
              langkey="desc.chrome_recomm"
              style={{ marginTop: 20, color: "white" }}
            >
              {isEmpty(window.lang["크롬 브라우저를 권장합니다."])
                ? "크롬 브라우저를 권장합니다."
                : window.lang["크롬 브라우저를 권장합니다."]}
            </p>
          </div>
          <div
            className="footer_notice_channel_temp"
            style={{ textAlign: "center" }}
          >
            <div className="content_wrap" style={{ margin: "20px 0" }}>
              <h4
                className=""
                langkey="title.footer.notice_chanel"
                style={{ fontSize: "18px", marginBottom: 10, color: "#fff" }}
              >
                {isEmpty(window.lang["공식 채널"])
                  ? "공식 채널"
                  : window.lang["공식 채널"]}{" "}
              </h4>
            </div>
            <div
              className="channel_wrap"
              style={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <div style={{ marginRight: 30 }}>
                <a href="https://t.me/" target="_blank">
                  <img
                    src="../images/upload/2024/0306/jnBV_PxPg_rPVY_pCTk.png"
                    width={50}
                  />
                </a>
              </div>
              <div>
                <a href="https://t.me/" target="_blank">
                  <img
                    src="../images/upload/2024/0306/3Tuk_bLpf_LX0w_rVKh.png"
                    width={50}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          background: "#222222",
          padding: 30,
        }}
      >
        <p className="copy">
          Copyright © <span className="">demo</span> Company. All rights
          reserved
        </p>
      </div>
      <div id="floatingBanner"></div>
    </div>
  );
};

export const MobileFootbar = (props) => {
  const { isAuthenticated, language } = props;

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  useEffect(() => {}, [language]);
  return (
    <div className="footer p-2">
      <div className="cs">
        <div className="inner mb-5">
          <div className="sec02 text-align-center text-center">
            <strong
              className=""
              langkey="new_theme.common.24hours_title"
              style={{ marginTop: 0 }}
            >
              {isEmpty(window.lang["운영시간"])
                ? "운영시간"
                : window.lang["운영시간"]}{" "}
              : 24{isEmpty(window.lang["시간"]) ? "시간" : window.lang["시간"]}
            </strong>
            <p>
              <span className="" langkey="new_theme.common.24hours_desc">
                {isEmpty(
                  window.lang[
                    "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                  ]
                )
                  ? "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                  : window.lang[
                      "모든 상담원은 24시간 고객님을 위해 대기하고 있습니다."
                    ]}{" "}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="foot_con mt-0">
        <p
          className="foot_logo invisible"
          id="main_footer_logo"
          style={{ visibility: "visible" }}
        ></p>
        <div
          className="footer_notice_channel_temp"
          style={{
            textAlign: "center",
            marginBottom: 10,
            background: "#222",
            padding: 20,
          }}
        >
          <div
            style={{
              marginBottom: 15,
              color: "#fff",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            {isEmpty(window.lang["공식 채널"])
              ? "공식 채널"
              : window.lang["공식 채널"]}
            <br />
            <p style={{ color: "#ccc" }}>
              {isEmpty(window.lang["채널 추가하고 실시간 알림 받기"])
                ? "채널 추가하고 실시간 알림 받기"
                : window.lang["채널 추가하고 실시간 알림 받기"]}
            </p>
          </div>
          <div
            className="channel_wrap"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div style={{ marginRight: 30 }}>
              <a href="https://t.me/" target="_blank">
                <img
                  src="../images/upload/2024/0306/jnBV_PxPg_rPVY_pCTk.png"
                  width={35}
                />
              </a>
            </div>
            <div>
              <a href="https://t.me/" target="_blank">
                <img
                  src="../images/upload/2024/0306/3Tuk_bLpf_LX0w_rVKh.png"
                  width={35}
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className="partners"
          style={{
            height: "100px",
            padding: "10px",
            background: "#222222",
          }}
        >
          <div
            className="swiper-container  footerBanner_marquee"
            id="footerBanner"
            style={{ paddingTop: 25, paddingBottom: 10 }}
          >
            <ul
              className="swiper-wrapper"
              style={{
                animation:
                  " 76s linear 0s infinite normal none running scroll-footerBanner",
              }}
            >
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TUt6_B90L_ms0z_wIKT.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/wLtD_hZPa_myUP_A2N5.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/cLBQ_GM2A_hJyF_5Xt1.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/bl6P_UzRi_AobQ_v8px.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/mu0z_5yQb_f7vV_bQvc.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rRTl_JoQJ_ccQv_uHDy.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/Ml3d_cNcQ_v5Kf_Vo3K.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/H64B_n6M0_O0cc_1DLR.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rdbX_EfE9_N53N_LrET.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/vc7Q_wP4B_g3qE_LVQI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gr39_98CY_rGto_pZ7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XsCs_qEiN_SYHQ_BDyX.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/FX9Y_rqT9_OI2q_GEO7.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XOqm_wxpB_0ZHY_0F7w.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/UE3K_1Ksa_Vkev_xh8h.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1025/9Mcc_Emhw_VpAy_Z2Rp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/3xcR_A8mj_xIYZ_6F9G.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/GaNl_royr_FLi6_Gv7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/LWai_q3Zp_qOaY_zcei.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gtuq_aYiO_NkPi_vo8p.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/EuP4_SpLR_Xwya_MNaW.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/AUc3_3oAv_PA8C_KjhJ.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/hPJr_b1zb_TNML_v3BH.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/t4Km_yKDA_Kqm8_2JkI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/u8Ex_Q8yV_QsOK_VhSM.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/ZZs2_OGyB_yn2i_cRb3.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0126/cAIj_Leip_DXxM_yD6C.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/SBDe_IonT_88Lz_Z2jf.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/rXAz_v8jc_g1sl_9TI9.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/n5sX_FiTr_sNiv_w79T.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/BuhV_T9xh_Ecyh_ZiRd.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/dqCZ_4kwE_3432_NA6R.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TaIA_1Ba8_yOUt_qTsL.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/h2t2_is0F_uzuv_822Q.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/77j0_UQAY_6Ox7_OG0X.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0304/ImQd_mPS6_fUCI_AFRp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/J8Np_Wpk7_RYeq_m2Ap.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TUt6_B90L_ms0z_wIKT.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/wLtD_hZPa_myUP_A2N5.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/cLBQ_GM2A_hJyF_5Xt1.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/bl6P_UzRi_AobQ_v8px.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/mu0z_5yQb_f7vV_bQvc.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rRTl_JoQJ_ccQv_uHDy.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/Ml3d_cNcQ_v5Kf_Vo3K.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/H64B_n6M0_O0cc_1DLR.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/rdbX_EfE9_N53N_LrET.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/vc7Q_wP4B_g3qE_LVQI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gr39_98CY_rGto_pZ7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XsCs_qEiN_SYHQ_BDyX.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/FX9Y_rqT9_OI2q_GEO7.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/XOqm_wxpB_0ZHY_0F7w.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/UE3K_1Ksa_Vkev_xh8h.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1025/9Mcc_Emhw_VpAy_Z2Rp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/3xcR_A8mj_xIYZ_6F9G.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/GaNl_royr_FLi6_Gv7b.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/LWai_q3Zp_qOaY_zcei.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/gtuq_aYiO_NkPi_vo8p.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/EuP4_SpLR_Xwya_MNaW.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/AUc3_3oAv_PA8C_KjhJ.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/hPJr_b1zb_TNML_v3BH.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/t4Km_yKDA_Kqm8_2JkI.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/u8Ex_Q8yV_QsOK_VhSM.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/ZZs2_OGyB_yn2i_cRb3.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0126/cAIj_Leip_DXxM_yD6C.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/SBDe_IonT_88Lz_Z2jf.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1112/rXAz_v8jc_g1sl_9TI9.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/n5sX_FiTr_sNiv_w79T.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/BuhV_T9xh_Ecyh_ZiRd.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/1110/dqCZ_4kwE_3432_NA6R.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/TaIA_1Ba8_yOUt_qTsL.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/h2t2_is0F_uzuv_822Q.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/77j0_UQAY_6Ox7_OG0X.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2024/0304/ImQd_mPS6_fUCI_AFRp.png"
                  alt=""
                />
              </li>
              <li className="swiper-slide footSlider">
                <img
                  src="../images/upload/2023/1115/J8Np_Wpk7_RYeq_m2Ap.png"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="util">
        <div
          className="inner"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-around",
            background: "#222222",
            paddingTop: 10,
            paddingBottom: 30,
            gap: 30,
            flexWrap: "wrap",
            backgroundColor: "#000",
          }}
        >
          <div className="w-100 d-flex justify-content-center">
            <div
              style={{
                padding: "10px 20px",
                border: "1px solid",
                borderRadius: "5px",
                marginRight: "10px",
                width: "130px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Link
                to="/inquiries/rule"
                className=""
                langkey="col.cs_center"
                onClick={onClickMemMenu}
              >
                {isEmpty(window.lang["고객센터"])
                  ? "고객센터"
                  : window.lang["고객센터"]}
              </Link>
            </div>
            <div
              style={{
                padding: "10px 20px",
                border: "1px solid",
                borderRadius: "5px",
                marginRight: "10px",
                width: "130px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Link
                to="/inquiries/question"
                className=""
                langkey="col.cs_center"
                onClick={onClickMemMenu}
              >
                {isEmpty(window.lang["1:1문의"])
                  ? "1:1문의"
                  : window.lang["1:1문의"]}
              </Link>
            </div>
          </div>
          <div className="mt-5">
            <p className="copy" style={{ color: "rgb(204, 204, 204)" }}>
              Copyright © <span className="">demo</span> Company. All rights
              reserved
            </p>
          </div>
          <div
            className="connectus_temp"
            style={{
              textAlign: "center",
              marginBottom: 60,
            }}
          >
            <div>
              <a href="https://www.google.com/chrome/" target="_blank">
                <img
                  src="../images/upload/2024/0120/yei4_MVux_V01J_eZfv.png"
                  alt=""
                  width={32}
                  height={32}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <MobileStickyFootbar />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  language: state.more.language,
});

export default connect(mapStateToProps, {})(Footbar);



// WEBPACK FOOTER //
// ./src/components/Layout/Footbar.js